export default {
	setUser (context, payload) {
		context.commit('SET_USER', payload)
		window.localStorage.setItem('USER', JSON.stringify(payload))
	},
	setNavigation (context, payload) {
		context.commit('SET_NAVIGATION', payload)
	},
	setAuth (context, payload) {
		payload.expires_at = payload.expires_in + Math.round(Date.now() / 1000)
		context.commit('SET_AUTH', payload)
		window.localStorage.setItem('AUTH', JSON.stringify(payload))
	},
	login (context, payload) {
		context.dispatch('setAuth', payload)
	},
	logout (context) {
		window.localStorage.removeItem('USER')
		window.localStorage.removeItem('AUTH')
		context.commit('SET_USER', {})
		context.commit('SET_AUTH', {})
	}
}
